import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { UncontrolledTooltip } from "reactstrap";
import { ReportSectionHeader } from "../SectionHeader";

const ClassPeriodTradingStatComponent = (props) => (

	<div>
		<ReportSectionHeader>
			<div id={"classPeriodTradingStatTitle"} className={"SectionHeaderInner"}>
				{props.isDandO === "true" || props.claimTypeId === 3 || props.claimTypeId === 4? "Securities Litigation Risk Evaluation Period":"Class Period Trading Statistics"}
			</div>
			<UncontrolledTooltip innerClassName={"table-tooltip-text"} placement="right"
				target={"classPeriodTradingStatTitle"}>
				{props.isDandO === "true"? "SAR Event Study Analysis related to potential violations of the Exchange Act and Rule 10b-5 are based on the high-risk adverse events identified by SAR and the application of a two-year evaluation period, if a custom evaluation period is not defined by the Subscriber.":"Class Period as presented in the corresponding securities class action complaint or per the commissioned inputs. The latter date corresponds to the trading date when stock price was affected by the corrective event."}
				
			</UncontrolledTooltip>
		</ReportSectionHeader>
		<ReportTable
			settings={[
				{
					header: 'Trading Day',
					accessor: 'date',
				},
				{
					header: 'Closing Stock Price',
					accessor: 'closingPrice',
					dollarValue: true,
					round2Decimals: true,
					centerRightJustified: true,
					tooltip: 'Closing stock price as reported by S&P Global Market Intelligence.'
				},
				{
					header: 'Shares Outstanding~(000s)', 
					accessor: 'totalSharesOutStanding',
					formatNumberWithCommas: true,
					inThousands: true,
					centerRightJustified: true,
					dollarValue: false,
					tooltip: 'Shares outstanding as reported by S&P Global Market Intelligence.',
					round2whole: true
				},
				{
					header: 'Approx. Market Cap.~(000s)', 
					accessor: 'approxMarketCap',
					dollarValue: true,
					formatNumberWithCommas: true,
					truncateDecimal: true,
					inThousands: true,
					centerRightJustified: true,
					tooltip: 'Approx. market cap. is equal to the product of the daily closing stock price and reported shares outstanding.'
				},
				{
					header: 'Daily Volume~(000s)', 
					accessor: 'dailyVolume',
					inThousands: true,
					dollarValue: false,
					formatNumberWithCommas: true,
					truncateDecimal: true,
					centerRightJustified: true,
					tooltip: 'Daily volume as reported by S&P Global Market Intelligence.'
				}
			]}
			data={props.classPeriodTradingStats}
			name={"classPeriodTradingStat"}
		/>
	</div>
);


export default ClassPeriodTradingStatComponent;


// WEBPACK FOOTER //
// ./src/common/components/ClassPeriodTradingStat/ClassPeriodTradingStatComponent.js